<template>
  <v-col>
    <v-form @submit.prevent="handleSubmitForm" ref="form">
      <v-col>
        <label class="labels">{{
          $t("sales.affiliates_program_limits_event_tickets")
        }}</label>
        <v-row>
          <v-col cols="5">
            <label required class="input-labels">
              {{ $t("sales.affiliates_program_limits_events") }}
            </label>
            <v-autocomplete
              v-model="selectedProduct"
              :items="allValidEvents"
              solo
              class="textDropdown"
              :label="$t('sales.affiliates_program_limits_event_placeholder')"
              chip
              deletable-chips
              clear-icon="mdi-close-circle-outline"
              item-text="descricao"
              item-value="idproduto"
              :no-data-text="$t('sales.affiliates_program_limits_event_no')"
              :color="$config.dados.corinputs"
              :item-color="$config.dados.corinputs"
              @input="
                selectedVariations = [];
                selectedProductError = '';
              "
              :error-messages="selectedProductError"
              return-object
            >
              <template v-slot:selection="{ item }">
                <v-chip>{{ item.descricao }}</v-chip>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="5" v-if="hasItemsVariations">
            <label required class="input-labels">
              {{ $t("sales.affiliates_program_limits_tickets") }}
            </label>
            <v-autocomplete
              v-model="selectedVariations"
              :items="itemsVariations"
              solo
              class="textDropdown"
              :label="$t('sales.affiliates_program_limits_tickets_placeholder')"
              chip
              multiple
              deletable-chips
              clear-icon="mdi-close-circle-outline"
              item-text="descricao_completa"
              item-value="idproduto_variacao"
              :no-data-text="$t('sales.affiliates_program_limits_no_tickets')"
              :color="$config.dados.corinputs"
              :item-color="$config.dados.corinputs"
              @input="selectedVariationsError = ''"
              :error-messages="selectedVariationsError"
            >
              <template v-slot:selection="{ item }">
                <v-chip close @click:close="removeVariantItem(item)">
                  {{
                    item.descricao_completa ||
                    getTranslatedText(item.descricao) ||
                    item.descricao
                  }}
                </v-chip>
              </template>
              <template v-slot:item="{ item }">
                {{
                  item.descricao_completa ||
                  getTranslatedText(item.descricao) ||
                  item.descricao
                }}
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-alert
          class="mb-8"
          border="left"
          colored-border
          type="warning"
          elevation="2"
        >
          {{ $t("sales.affiliates_program_limits_event_tickets_validation") }}
        </v-alert>
        <label required class="labels">{{
          $t("sales.affiliates_program_limit_tickets")
        }}</label>
        <v-radio-group v-model="hasTicketLimit">
          <v-radio
            :label="$t('sales.affiliates_program_limited_tickets')"
            :color="$config.dados.corinputs"
            value="true"
          ></v-radio>
          <v-text-field
            v-if="hasTicketLimit === 'true'"
            solo
            dense
            outlined
            :label="$t('sales.affiliates_program_limited_affiliate_tickets')"
            :color="$config.dados.corinputs"
            :placeholder="
              $t(
                'sales.affiliates_program_limited_affiliate_tickets_placeholder'
              )
            "
            v-model="limitValue"
            type="number"
            class="textinput"
            style="max-width: 300px; margin-bottom: 15px"
            :rules="[rules.maxLength]"
            @input="limitValueError = ''"
            :error-messages="limitValueError"
          ></v-text-field>
          <v-radio
            :label="$t('sales.affiliates_program_unlimited_affiliate_tickets')"
            :color="$config.dados.corinputs"
            value="false"
          ></v-radio>
          <small
            >{{ $t("sales.affiliates_program_limited_affiliate_tickets_info") }}
          </small>
        </v-radio-group>
        <v-alert
          class="mb-8"
          border="left"
          colored-border
          type="info"
          elevation="2"
        >
          {{
            $t(
              "sales.affiliates_program_limited_affiliate_tickets_disponiblity_info"
            )
          }}
        </v-alert>
      </v-col>
      <v-col
        ><v-btn
          class="btn-color"
          :color="$config.dados.corinputs"
          style="color: white"
          type="submit"
        >
          {{ $t("sales.affiliates_program_continue") }}
        </v-btn>
        <v-btn text @click="stepBackProgram()">
          {{ $t("sales.affiliates_program_return") }}
        </v-btn></v-col
      >
    </v-form>
  </v-col>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import CupomMixins from "@/mixins/Cupom.mixins.js";
import { getTranslatedText } from "@/utils";
export default {
  name: "Limits",
  mixins: [CupomMixins],
  data() {
    return {
      getTranslatedText,
      hasTicketLimit: null,
      limitValue: null,
      ticketType: null,
      selectedProduct: null,
      selectedVariations: [],
      selectedProductError: "",
      selectedVariationsError: "",
      hasTicketLimitError: "",
      limitValueError: "",
      rules: {
        maxLength: value =>
          value?.length <= 5 || this.$t("sales.affiliates_program_max_length"),
      },
    };
  },
  computed: {
    ...mapGetters([
      "allEvents",
      "storeSequencial",
      "dataProgram",
      "storeInfo",
      "storeSlug",
      "allEvents",
    ]),
    allValidEvents() {
      return this.allEvents.filter(event =>
        event.canal_venda.includes("ECOMMERCE;IFRAME;LINK")
      );
    },

    itemsVariations() {
      return this.selectedProduct?.variantes?.variacoes_produto
        ? this.selectedProduct.variantes?.variacoes_produto.filter(
            variation =>
              variation.status !== "ESGOTADO" &&
              variation.tipo !== "RECARGA" &&
              variation.tipo !== "PRODUTO"
          )
        : [];
    },

    hasItemsVariations() {
      return this.itemsVariations?.length > 0;
    },
  },
  methods: {
    ...mapActions([
      "fetchEvents",
      "nextStepProgram",
      "stepBackProgram",
      "showSnackbarError",
    ]),
    ...mapMutations(["setDataProgram"]),
    handleSubmitForm() {
      if (
        this.selectedProduct === null ||
        !this.selectedProduct ||
        this.selectedProduct === undefined
      ) {
        this.selectedProductError = this.$t(
          "sales.affiliates_program_limits_events_required"
        );
        return;
      }
      if (
        this.selectedProduct &&
        this.selectedProduct?.variantes?.variacoes_produto.length > 0 &&
        this.selectedVariations.length === 0
      ) {
        this.selectedVariationsError = this.$t(
          "sales.affiliates_program_limits_ticket_required"
        );
        return;
      }
      if (this.hasTicketLimit === null) {
        this.showSnackbarError(
          this.$t("sales.affiliates_program_limits_limit_value_required")
        );
        this.hasTicketLimitError = this.$t(
          "sales.affiliates_program_limits_limit_value_required"
        );
        return;
      }
      if (this.hasTicketLimit === "true" && !this.limitValue) {
        this.limitValueError = this.$t(
          "sales.affiliates_program_limits_ticket_value_required"
        );
        return;
      }
      if (this.hasTicketLimit === "true" && this.limitValue > 99999) {
        this.limitValueError = this.$t("sales.affiliates_program_max_length");
        return;
      }
      const limitData = {
        limit: this.limitValue,
        products: this.selectedVariations || [],
        product: this.selectedProduct,
      };
      this.setDataProgram({
        ...this.dataProgram,
        ...limitData,
      });
      this.nextStepProgram();
    },
    removeVariantItem(item) {
      this.selectedVariations = this.selectedVariations.filter(
        event => event !== item.idproduto_variacao
      );
    },
    filterSelectedProducts() {
      if (typeof this.selectedProduct === "string") {
        const selectedProductId = this.selectedProduct;
        const filteredProduct = this.allEvents.find(
          produto => produto.idproduto === selectedProductId
        );
        if (filteredProduct) {
          this.selectedProduct = filteredProduct;
        }
      }
    },
  },
  mounted() {
    this.fetchEvents({
      producerId: this.storeSequencial,
      periodo_valido: true,
    });
  },
  watch: {
    "$store.getters.dataProgram": {
      handler: function (val) {
        if (!this.selectedProduct) {
          this.selectedProduct = val?.idproduto;
          this.selectedVariations = val?.nidproduto_variacao?.split(";");
          this.hasTicketLimit = val?.limite ? "true" : "false";
          this.limitValue = val?.limite;
        }
        this.filterSelectedProducts();
      },
      deep: true,
    },
    hasTicketLimit(val) {
      if (val === "false") {
        this.limitValue = null;
      }
    },
  },
};
</script>

<style scoped>
.labels {
  font-size: 16px;
  font-weight: 800;
}
</style>
